var WillRegistrationResult = {
    SUCCESS : 0,
    GROUP_CONFLICT : 1,
    TOPIC_TREE_CONFLICT : 2
};

WillRegistrationResult.toString = function() {
    return "WillRegistrationResult";
};

module.exports = WillRegistrationResult;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/wills/will-registration-result.js
// module id = 221
// module chunks = 1